var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { TextSizeType } from '../../../../shared/styling/BaseText/BaseText.enum';
import { Text } from '../../../Atoms/Text/Text';
import BaseInputRadioContainer from '../BaseComponents/BaseInputRadioContainer';
const InputRadio = forwardRef((_a, ref) => {
    var { name, id, label, customCss, helperText, errorText, touched, error, value, checked, disabled } = _a, delegated = __rest(_a, ["name", "id", "label", "customCss", "helperText", "errorText", "touched", "error", "value", "checked", "disabled"]);
    const theme = useContext(ThemeContext);
    return (_jsxs(BaseInputRadioContainer, Object.assign({ customCss: customCss, disabled: disabled, error: error }, { children: [_jsx("input", Object.assign({ ref: ref, checked: checked, disabled: disabled, id: id, name: name, type: "radio", value: value }, delegated), void 0), _jsx(Text, Object.assign({ as: "label", htmlFor: id, textSize: TextSizeType.TEXT16 }, { children: label }), void 0), helperText && (_jsx(Text, Object.assign({ color: theme.colors.text02, textSize: TextSizeType.TEXT14 }, { children: helperText }), void 0)), errorText && touched && error && (_jsx(Text, Object.assign({ color: theme.colors.supportError01, textSize: TextSizeType.TEXT14 }, { children: errorText }), void 0))] }), void 0));
});
export default InputRadio;
//# sourceMappingURL=InputRadio.js.map